import React from "react"
import { Box, componentStyles } from "@mallardbay/lib-react-components"

import CheckoutFlowPackageSections from "~components/pages/listing/checkout/checkout-flow/checkout-flow-package-sections"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import PackageContinueButton from "~components/pages/listing/pricing/package-continue-button"
import ListingContactBanner from "~components/pages/listing/listing-contact-banner"
import { useIsMobile } from "~components/shared/todo-lib-react-components/hooks/use-is-mobile"
import { CHECKOUT_STEPS } from "~config/constants"

export default function WidgetCheckoutFlowPackageSelection() {
    const { listing, packageState, goToStep } = useCheckoutFlow()
    const isMobile = useIsMobile()
    const styles = useStyles()

    return (
        <>
            <CheckoutFlowPackageSections />
            <PackageContinueButton
                handleContinueClick={() =>
                    goToStep({
                        step: CHECKOUT_STEPS.DATES,
                        package_id: packageState.pricing_package_id,
                    })
                }
                isDisabled={!packageState.pricing_package_id}
                isMobile={isMobile}
                hideContinueButton={!listing?.next_availability}
            />
            <Box style={styles.contactContainer}>
                <ListingContactBanner listing={listing} />
            </Box>
        </>
    )
}

function useStyles() {
    return componentStyles({
        contactContainer: {
            // Margin offsets for rendering in the bottom sheet on mobile.
            marginTop: { base: "-4rem", sm: 0 },
            marginBottom: { base: "5rem", sm: 0 },
        },
    })
}
